import script from "./ReplenishInfo.vue?vue&type=script&lang=ts&setup=true"
export * from "./ReplenishInfo.vue?vue&type=script&lang=ts&setup=true"

import "./ReplenishInfo.vue?vue&type=style&index=0&id=20dc026c&lang=scss&scoped=true"

import exportComponent from "/var/jenkins_home/workspace/oa-sales-user/oa-admin-web/sales-web/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-20dc026c"]])

export default __exports__